// Lightweight event tracking helper: fires to Google Analytics (gtag) and PostHog.
export const track = (event, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
  } catch (e) {
    // no-op
  }
  try {
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, params);
    }
  } catch (e) {
    // no-op
  }
};
